import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=9a895770&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=9a895770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a895770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a895770')) {
      api.createRecord('9a895770', component.options)
    } else {
      api.reload('9a895770', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=9a895770&scoped=true&", function () {
      api.rerender('9a895770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/ContactForm.vue"
export default component.exports